// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landingBannerSkeleton {
  position: relative;
  margin: 36px 0;
  z-index: 0;
  width: 100%;
  height: 300px;
  border-radius: 20px;
}
@media (max-width: 768px) {
  .landingBannerSkeleton {
    height: 150px;
    border-radius: 16px;
    margin: 24px 0;
  }
}

.whatsNewCardSkeleton {
  position: relative;
  margin: 32px auto;
  padding-left: 20px;
  padding-right: -20px;
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .whatsNewCardSkeleton {
    padding-top: 0;
  }
}
.whatsNewCardSkeleton .header {
  display: flex;
  justify-content: space-between;
}
.whatsNewCardSkeleton .header .avatarGroup {
  display: flex;
  gap: 16px;
}
.whatsNewCardSkeleton .cardGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  gap: 20px;
  height: 280px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .whatsNewCardSkeleton .cardGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 990px) {
  .whatsNewCardSkeleton .cardGrid {
    grid-template-columns: repeat(3, 1fr);
  }
}
.whatsNewCardSkeleton .cardGrid .cardSkeleton {
  position: relative;
  padding: 20px 0;
}
.whatsNewCardSkeleton .cardGrid .cardSkeleton .mainSkeleton {
  border-radius: 20px;
}
.whatsNewCardSkeleton .cardGrid .cardSkeleton .bottomSkeleton {
  position: absolute;
  width: 100%;
  left: 50%;
  bottom: -32px;
  transform: translateX(-50%);
}
@media (max-width: 990px) {
  .whatsNewCardSkeleton .cardGrid .cardSkeleton .bottomSkeleton {
    bottom: 16px;
  }
}
.whatsNewCardSkeleton .cardGrid .cardSkeleton .bottomSkeleton .skeletonView {
  border-radius: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.skeletonPopularCategoryUI {
  position: relative;
  margin: 32px auto;
  padding-left: 20px;
  padding-right: -20px;
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .skeletonPopularCategoryUI {
    padding-top: 0;
    padding: 0 20px;
  }
}
.skeletonPopularCategoryUI .popularUI {
  display: flex;
  justify-content: space-between;
}
.skeletonPopularCategoryUI .popularUI .avatarGroup {
  display: flex;
  gap: 16px;
}
.skeletonPopularCategoryUI .cardGrid {
  display: grid;
  grid-gap: 20px;
  gap: 20px;
  height: 170px;
  overflow: hidden;
  grid-template-columns: repeat(6, 1fr);
}
@media (max-width: 768px) {
  .skeletonPopularCategoryUI .cardGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 990px) {
  .skeletonPopularCategoryUI .cardGrid {
    grid-template-columns: repeat(4, 1fr);
  }
}
.skeletonPopularCategoryUI .cardGrid .cardSkeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 0;
}
.skeletonPopularCategoryUI .cardGrid .cardSkeleton .bottomSkeleton {
  left: 50%;
  transform: translateX(-50%);
}

.popularRetailerSkeletonUI {
  position: relative;
  margin: 32px auto;
  padding-left: 20px;
  padding-right: -20px;
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .popularRetailerSkeletonUI {
    padding-top: 0;
    padding: 0 20px;
  }
}
.popularRetailerSkeletonUI .popularUI {
  display: flex;
  justify-content: space-between;
}
.popularRetailerSkeletonUI .popularUI .avatarGroup {
  display: flex;
  gap: 16px;
}
.popularRetailerSkeletonUI .cardGrid {
  display: grid;
  grid-gap: 20px;
  gap: 20px;
  height: 75px;
  overflow: hidden;
  grid-template-columns: repeat(8, 1fr);
}
@media (max-width: 768px) {
  .popularRetailerSkeletonUI .cardGrid {
    height: 120px;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 990px) {
  .popularRetailerSkeletonUI .cardGrid {
    height: 120px;
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 1100px) {
  .popularRetailerSkeletonUI .cardGrid {
    height: 120px;
    grid-template-columns: repeat(6, 1fr);
  }
}
.popularRetailerSkeletonUI .cardGrid .cardSkeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.popularCategoryBanner {
  position: relative;
  max-width: 1200px;
  width: 100%;
  margin: 32px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .popularCategoryBanner {
    padding-top: 0;
    padding-left: 20px;
    padding-right: -20px;
  }
}
.popularCategoryBanner .bannerSection {
  position: relative;
  margin: 0 auto;
  height: 260px;
  overflow: hidden;
  display: block;
}
@media (max-width: 768px) {
  .popularCategoryBanner .bannerSection {
    height: 160px;
  }
}
@media (max-width: 1300px) {
  .popularCategoryBanner .bannerSection {
    display: none;
  }
}
.popularCategoryBanner .largeScreenBanner {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
@media (max-width: 1300px) {
  .popularCategoryBanner .largeScreenBanner {
    margin: 0 20px;
    display: none;
  }
}
.popularCategoryBanner .largeScreenBanner .banner {
  flex: 1 1;
}
.popularCategoryBanner .largeScreenBanner .banner .bannerInfo {
  border-radius: 16px;
  height: 320px;
  width: 625px;
}
@media (max-width: 768px) {
  .popularCategoryBanner .largeScreenBanner .banner .bannerInfo {
    height: 288px;
    width: 100%;
  }
}

.skeletonCardDesign {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  padding-bottom: 44px;
  position: relative;
}
@media (max-width: 768px) {
  .skeletonCardDesign {
    margin-top: 0;
    padding-left: 20px;
    padding-right: -20px;
  }
}
.skeletonCardDesign .giftcardSection {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.skeletonCardDesign .giftcardSection .section {
  display: flex;
  gap: 10px;
  align-items: center;
}
.skeletonCardDesign .giftcardSection .carousalSection {
  display: flex;
  gap: 16px;
}
.skeletonCardDesign .sectionStructure {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 16px;
  gap: 16px;
  height: 200px;
  overflow: hidden;
  padding-top: 28px;
}
@media (max-width: 768px) {
  .skeletonCardDesign .sectionStructure {
    padding-top: 14px;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 990px) {
  .skeletonCardDesign .sectionStructure {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 1100px) {
  .skeletonCardDesign .sectionStructure {
    grid-template-columns: repeat(5, 1fr);
  }
}
.skeletonCardDesign .sectionStructure .skeletonStructure {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.preciousMetalSkeleton {
  position: relative;
  max-width: 1200px;
  width: 100%;
  margin: 32px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 768px) {
  .preciousMetalSkeleton {
    padding-top: 0;
    padding-left: 20px;
    padding-right: -20px;
  }
}
.preciousMetalSkeleton .sectionPrecious {
  display: flex;
  justify-content: space-between;
}
.preciousMetalSkeleton .sectionPrecious .avatarGroup {
  display: flex;
  gap: 16px;
}
.preciousMetalSkeleton .preciousSkeleton {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
  gap: 20px;
  height: 280px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .preciousMetalSkeleton .preciousSkeleton {
    grid-template-columns: repeat(2, 1fr);
  }
}
.preciousMetalSkeleton .preciousSkeleton .cardDesign {
  position: relative;
  padding: 20px 0;
}
.preciousMetalSkeleton .preciousSkeleton .cardDesign .mainSkeleton {
  border-radius: 20px;
}
.preciousMetalSkeleton .preciousSkeleton .cardDesign .bottomSkeleton {
  position: absolute;
  width: 100%;
  left: 50%;
  bottom: -32px;
  transform: translateX(-50%);
}
@media (max-width: 990px) {
  .preciousMetalSkeleton .preciousSkeleton .cardDesign .bottomSkeleton {
    bottom: 16px;
  }
}
.preciousMetalSkeleton .preciousSkeleton .cardDesign .bottomSkeleton .skeletonView {
  border-radius: 20px;
  left: 50%;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/Components/Partials/SkeletonUI/LandingPageSkeleton/LandingPageSkeleton.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAF;ACKE;EDXF;IASI,aAAA;IACA,mBAAA;IACA,cAAA;EACF;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;ACdE;EDIF;IAYI,cAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,8BAAA;AAEJ;AAAI;EACE,aAAA;EACA,SAAA;AAEN;AAEE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AClCE;ED6BA;IAQI,qCAAA;EACJ;AACF;ACjCE;EDuBA;IAWI,qCAAA;EAGJ;AACF;AADI;EACE,kBAAA;EACA,eAAA;AAGN;AADM;EACE,mBAAA;AAGR;AAAM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;AAER;ACpDE;ED6CI;IAQI,YAAA;EAGR;AACF;AADQ;EACE,mBAAA;EACA,SAAA;EACA,2BAAA;AAGV;;AAIA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AChFE;EDwEF;IAYI,cAAA;IACA,eAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AAEI;EACE,aAAA;EACA,SAAA;AAAN;AAIE;EACE,aAAA;EACA,cAAA;EAAA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,qCAAA;AAFJ;ACrGE;EDkGA;IAQI,qCAAA;EADJ;AACF;ACpGE;ED4FA;IAWI,qCAAA;EACJ;AACF;AACI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AACN;AACM;EACE,SAAA;EACA,2BAAA;AACR;;AAKA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;ACrIE;ED8HF;IAYI,cAAA;IACA,eAAA;EADF;AACF;AAGE;EACE,aAAA;EACA,8BAAA;AADJ;AAGI;EACE,aAAA;EACA,SAAA;AADN;AAKE;EACE,aAAA;EACA,cAAA;EAAA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;AAHJ;AC1JE;EDwJA;IAQI,aAAA;IACA,qCAAA;EAFJ;AACF;AC1JE;EDkJA;IAYI,aAAA;IACA,qCAAA;EAAJ;AACF;AC1JE;ED4IA;IAgBI,aAAA;IACA,qCAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEN;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AC5LE;EDoLF;IAWI,cAAA;IACA,kBAAA;IACA,oBAAA;EACF;AACF;AACE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AACJ;AC1ME;EDoMA;IAQI,aAAA;EAEJ;AACF;ACvLE;ED4KA;IAYI,aAAA;EAGJ;AACF;AAAE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAEJ;ACrME;ED4LA;IAUI,cAAA;IACA,aAAA;EAGJ;AACF;AADI;EACE,SAAA;AAGN;AADM;EACE,mBAAA;EACA,aAAA;EACA,YAAA;AAGR;AC3OE;EDqOI;IAMI,aAAA;IACA,WAAA;EAIR;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;AACF;AC5PE;EDmPF;IAWI,aAAA;IACA,kBAAA;IACA,oBAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AAEJ;AAAI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAEN;AACI;EACE,aAAA;EACA,SAAA;AACN;AAGE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AC1RE;EDqRA;IASI,iBAAA;IACA,qCAAA;EAAJ;AACF;AC1RE;ED+QA;IAcI,qCAAA;EACJ;AACF;ACzRE;EDyQA;IAkBI,qCAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAEN;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AC3TE;EDmTF;IAWI,cAAA;IACA,kBAAA;IACA,oBAAA;EACF;AACF;AACE;EACE,aAAA;EACA,8BAAA;AACJ;AACI;EACE,aAAA;EACA,SAAA;AACN;AAGE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;EACA,aAAA;EACA,gBAAA;AADJ;ACjVE;ED6UA;IAQI,qCAAA;EAAJ;AACF;AAEI;EACE,kBAAA;EACA,eAAA;AAAN;AAEM;EACE,mBAAA;AAAR;AAGM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;AADR;AC9VE;ED0VI;IAQI,YAAA;EAAR;AACF;AAEQ;EACE,mBAAA;EACA,SAAA;EACA,2BAAA;AAAV","sourcesContent":["@import \"src/Styles/theme.scss\";\n.landingBannerSkeleton {\n  position: relative;\n  margin: 36px 0;\n  z-index: 0;\n  width: 100%;\n  height: 300px;\n  border-radius: 20px;\n  \n  @include respond-md {\n    height: 150px;\n    border-radius: 16px;\n    margin: 24px 0;\n  }\n}\n\n.whatsNewCardSkeleton {\n  position: relative;\n  margin: 32px auto;\n  padding-left: 20px;\n  padding-right: -20px;\n  max-width: 1200px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include respond-md {\n    padding-top: 0;\n  }\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n\n    .avatarGroup {\n      display: flex;\n      gap: 16px;\n    }\n  }\n\n  .cardGrid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    height: 280px;\n    overflow: hidden;\n    \n    @include respond-md {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    @include respond-lg {\n      grid-template-columns: repeat(3, 1fr);\n    }\n\n    .cardSkeleton {\n      position: relative;\n      padding: 20px 0;\n\n      .mainSkeleton {\n        border-radius: 20px;\n      }\n\n      .bottomSkeleton {\n        position: absolute;\n        width: 100%;\n        left: 50%;\n        bottom: -32px;\n        transform: translateX(-50%);\n\n        @include respond-lg {\n          bottom: 16px;\n        }\n\n        .skeletonView {\n          border-radius: 20px;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n    }\n  }\n}\n\n.skeletonPopularCategoryUI{\n  position: relative;\n  margin: 32px auto;\n  padding-left: 20px;\n  padding-right: -20px;\n  max-width: 1200px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include respond-md {\n    padding-top: 0;\n    padding: 0 20px;\n  }\n\n  .popularUI{\n    display: flex;\n    justify-content: space-between;\n\n    .avatarGroup {\n      display: flex;\n      gap: 16px;\n    }\n  }\n\n  .cardGrid {\n    display: grid;\n    gap: 20px;\n    height: 170px;\n    overflow: hidden;\n    grid-template-columns: repeat(6, 1fr);\n    \n    @include respond-md {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    @include respond-lg {\n      grid-template-columns: repeat(4, 1fr);\n    }\n\n    .cardSkeleton {\n      display: flex;\n      flex-direction: column;\n      gap: 14px;\n      padding: 20px 0;\n\n      .bottomSkeleton{\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n  }\n}\n\n.popularRetailerSkeletonUI{\n  position: relative;\n  margin: 32px auto;\n  padding-left: 20px;\n  padding-right: -20px;\n  max-width: 1200px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include respond-md {\n    padding-top: 0;\n    padding: 0 20px;\n  }\n\n  .popularUI{\n    display: flex;\n    justify-content: space-between;\n\n    .avatarGroup {\n      display: flex;\n      gap: 16px;\n    }\n  }\n\n  .cardGrid {\n    display: grid;\n    gap: 20px;\n    height: 75px;\n    overflow: hidden;\n    grid-template-columns: repeat(8, 1fr);\n    \n    @include respond-md {\n      height: 120px;\n      grid-template-columns: repeat(2, 1fr);\n    }\n    @include respond-lg {\n      height: 120px;\n      grid-template-columns: repeat(4, 1fr);\n    }\n    @include respond-xlg {\n      height: 120px;\n      grid-template-columns: repeat(6, 1fr);\n    }\n\n    .cardSkeleton {\n      display: flex;\n      flex-direction: column;\n      gap: 14px;\n    }\n  }\n}\n\n.popularCategoryBanner {\n  position: relative;\n  max-width: 1200px;\n  width: 100%;\n  margin: 32px auto;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  \n  @include respond-md {\n    padding-top: 0;\n    padding-left: 20px;\n    padding-right: -20px;\n  }\n\n  .bannerSection {\n    position: relative;\n    margin: 0 auto;\n    height: 260px;\n    overflow: hidden;\n    display: block;\n\n    @include respond-md {\n      height: 160px;\n    }\n\n    @include respond-xxxlg {\n      display: none;\n    }\n  }\n\n  .largeScreenBanner {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 32px;\n\n    @include respond-xxxlg {\n      margin: 0 20px;\n      display: none;\n    }\n\n    .banner {\n      flex: 1 1 0%;\n\n      .bannerInfo {\n        border-radius: 16px;\n        height: 320px;\n        width: 625px;\n\n        @include respond-md {\n          height: 288px;\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.skeletonCardDesign {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 44px;\n  position: relative;\n\n  @include respond-md {\n    margin-top: 0;\n    padding-left: 20px;\n    padding-right: -20px;\n  }\n\n  .giftcardSection {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: space-between;\n\n    .section {\n      display: flex;\n      gap: 10px;\n      align-items: center;\n    }\n\n    .carousalSection {\n      display: flex;\n      gap: 16px;\n    }\n  }\n\n  .sectionStructure {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 16px;\n    height: 200px;\n    overflow: hidden;\n    padding-top: 28px;\n    \n    @include respond-md {\n      padding-top: 14px;\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @include respond-lg {\n      grid-template-columns: repeat(4, 1fr);\n    }\n\n    @include respond-xlg {\n      grid-template-columns: repeat(5, 1fr);\n    }\n\n    .skeletonStructure {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n    }\n  }\n}\n\n.preciousMetalSkeleton {\n  position: relative;\n  max-width: 1200px;\n  width: 100%;\n  margin: 32px auto;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  @include respond-md {\n    padding-top: 0;\n    padding-left: 20px;\n    padding-right: -20px;\n  }\n\n  .sectionPrecious {\n    display: flex;\n    justify-content: space-between;\n\n    .avatarGroup {\n      display: flex;\n      gap: 16px;\n    }\n  }\n\n  .preciousSkeleton {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    height: 280px;\n    overflow: hidden;\n\n    @include respond-md {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    .cardDesign {\n      position: relative;\n      padding: 20px 0;\n\n      .mainSkeleton {\n        border-radius: 20px;\n      }\n\n      .bottomSkeleton {\n        position: absolute;\n        width: 100%;\n        left: 50%;\n        bottom: -32px;\n        transform: translateX(-50%);\n\n        @include respond-lg {\n          bottom: 16px;\n        }\n\n        .skeletonView {\n          border-radius: 20px;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n    }\n  }\n}","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
